import { render } from "./CreateAccountForm.vue?vue&type=template&id=37e6895e"
import script from "./CreateAccountForm.vue?vue&type=script&lang=js"
export * from "./CreateAccountForm.vue?vue&type=script&lang=js"

import "./CreateAccountForm.vue?vue&type=style&index=0&id=37e6895e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__